import { TableCell } from "./types";

export const initialTableCellState: TableCell = {
  selectMode: true,
};
